/**
 * What the page for firms tells search engines — ONE copy, read by today's page (src/pages/ForEnterprise.tsx) and
 * its rebuild in the new design (src/design/pavilion/pages/for-enterprise/), as src/config/homeSeo.ts serves both
 * home pages (PV4, design record §7b). Read by the guest chat's knowledge source for "/for-enterprise": each
 * `title:` / `description:` stays on one line.
 */
export const FOR_ENTERPRISE_CANONICAL_URL = 'https://prest0.ai/for-enterprise';

/** The props both pages hand to <SeoHead>. */
export const FOR_ENTERPRISE_SEO = {
  title: 'AI Employees for Law & Finance | prest0',
  description: 'Deploy a dedicated AI employee for law or finance — private infrastructure, deep workflow support, and go-live in weeks, not quarters.',
  keywords: 'AI for law, finance, dedicated infrastructure, prest0',
  canonicalUrl: FOR_ENTERPRISE_CANONICAL_URL,
} as const;
